export default {
  data() {
    return {
      dropdown: {
        target: null,

        items: [],

        filter: '',
        filterEnabled: false,

        focused: false,

        multiple: false,
        selected: {},
        showSelected: false,

        itemText: 'text',
        itemValue: 'value',
      },
      dd: {
        target: null,
      },
    };
  },
  computed: {
    dropdownItems() {
      if (this.dropdown.filterEnabled) {
        let filter = this.dropdown.filter.toLowerCase();
        if (this.dropdown.multiple) {
          filter = filter.split(',').pop().trim();
        }
        return this.dropdown.items.filter(item => item[this.dropdown.itemText].toLowerCase().includes(filter));
      }
      return this.dropdown.items;
    },
  },
  methods: {
    dropdownGetValue(target, projectFieldValue) {
      if (target === this.dropdown.target) {
        if (this.dropdown.filterEnabled) {
          return this.dropdown.filter;
        }
        // if (this.dropdown.focused) {
        //   return `${Object.values(this.dropdown.selected).join(', ')}, `;
        // }
        if (this.dropdown.multiple && this.dropdown.showSelected) {
          return Object.values(this.dropdown.selected).join(', ');
        }
      }
      return projectFieldValue;
    },
    dropdownSetFilter(value) {
      this.dropdown.filter = value;
      this.dropdown.filterEnabled = true;
    },
    dropdownShow(target, items = [], options = {}) {
      if (!items.length) {
        return;
      }
      if (this.dropdown.target !== target) {
        // hide old
        this.dropdownHide();

        // set default values
        this.dropdown.filter = target.value;

        this.dropdown.focused = true;

        this.dropdown.multiple = options.multiple || false;

        this.dropdown.itemText = options.itemText || 'text';
        this.dropdown.itemValue = options.itemValue || 'value';

        (options.selected || []).forEach((value) => {
          const item = items.find(item => item[this.dropdown.itemValue] === value);
          this.$set(this.dropdown.selected, value, item[this.dropdown.itemText]);
        });

        this.dropdown.items = typeof items[0] === 'string' ? items
          .map(item => ({ [this.dropdown.itemText]: item, [this.dropdown.itemValue]: item })) : items;

        // show new
        this.$nextTick(() => {
          this.dropdown.target = target;
        });
      }
    },
    dropdownHide() {
      if (this.dropdown.target) {
        if (this.dropdown.multiple) {
          const event = document.createEvent('HTMLEvents');
          event.selectedValues = Object.keys(this.dropdown.selected);
          event.initEvent('dropdown-hide', true, true);
          this.dropdown.target.dispatchEvent(event);
        }
      }
      this.dropdown.target = null;
      this.dropdown.filterEnabled = false;
      this.dropdown.selected = {};
    },
    dropdownOnClickAway($event) {
      if ($event.target !== this.dropdown.target) {
        this.dropdownHide();
      }
    },
    dropdownOnClickItem(item) {
      const event = document.createEvent('HTMLEvents');
      event.selectedValue = item[this.dropdown.itemValue];
      event.initEvent('dropdown-select', true, true);
      this.dropdown.target.dispatchEvent(event);

      this.dropdown.focused = false;

      if (!this.dropdown.multiple) {
        this.dropdownHide();
      } else {
        if (this.dropdown.selected[item[this.dropdown.itemValue]]) {
          this.$delete(this.dropdown.selected, item[this.dropdown.itemValue]);
        } else {
          this.$set(this.dropdown.selected, item[this.dropdown.itemValue], item[this.dropdown.itemText]);
        }
        this.dropdown.showSelected = true;
        this.dropdown.filterEnabled = false;
      }
    },
    //
    //
    //
    dropdownFocus($event) {
      console.log('dd focus');
      this.dd.target = $event.target;
      // this.dd.target.addEventListener('click', this.dropdownClick);
    },
    dropdownBlur() {
      console.log('dd blur');
      // this.dd.target.removeEventListener('click', this.dropdownClick);
      this.dd.target = null;
    },
    dropdownClick() {
      console.log('dd click');
    },
  },
};
